import { AttributeTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";

export const getIDOptionsByAttributeType = (content: AXNUIContent, type: AttributeTypes) => {
	switch (type) {
		case AttributeTypes.LICENSE_OR_ID_CARD:
			return [
				{
					label: content.form.pickerInput.driverLicenseOptionLabel,
					value: 'license',
					id: 'option-license'
				},
				{
					label: content.form.pickerInput.idCardOptionLabel,
					value: 'idcard',
					id: 'option-idcard'
				}
			];
		case AttributeTypes.LICENSE_OR_PASSPORT:
		case AttributeTypes.LICENSE_OR_PASSPORT_OR_BROWSE:
		case AttributeTypes.INTERNATIONAL_LICENSE_OR_PASSPORT:
			return [
				{
					label: content.form.pickerInput.driverLicenseOptionLabel,
					value: 'license',
					id: 'option-license'
				},
				{
					label: content.form.pickerInput.passportOptionLabel,
					value: 'passport',
					id: 'option-passport'
				}
			];
		case AttributeTypes.LICENSE_PASSPORT_OR_ID_CARD:
			return [
				{
					label: content.form.pickerInput.driverLicenseOptionLabel,
					value: 'license',
					id: 'option-license'
				},
				{
					label: content.form.pickerInput.passportOptionLabel,
					value: 'passport',
					id: 'option-passport'
				},
				{
					label: content.form.pickerInput.idCardOptionLabel,
					value: 'idcard',
					id: 'option-idcard'
				}
			];
		case AttributeTypes.PASSPORT_OR_ID_CARD:
			return [
				{
					label: content.form.pickerInput.passportOptionLabel,
					value: 'passport',
					id: 'option-passport'
				},
				{
					label: content.form.pickerInput.idCardOptionLabel,
					value: 'idcard',
					id: 'option-idcard'
				}
			];
		case AttributeTypes.AADHAR_PAN_OR_PASSPORT:
			return [
				{
					label: content.form.pickerInput.aadharCardOptionLabel,
					value: 'aadhar',
					id: 'option-adharcard'
				},
				{
					label: content.form.pickerInput.panCardOptionLabel,
					value: 'pan',
					id: 'option-pannumber'
				},
				{
					label: content.form.pickerInput.passportOptionLabel,
					value: 'passport',
					id: 'option-passport'
				}
			];
		default:
			return [];
	}
};

export const getIDOptionValidationTextByAttributeType = (content: AXNUIContent, value: string, attributeType: AttributeTypes) => {
	if (
		value === 'license' &&
		[AttributeTypes.LICENSE_OR_ID_CARD, AttributeTypes.INTERNATIONAL_LICENSE_OR_PASSPORT, AttributeTypes.LICENSE_PASSPORT_OR_ID_CARD].includes(
			attributeType
		)
	) {
		return content.form.pickerInput.validDLText;
	}
	if (
		value === 'license' &&
		[AttributeTypes.LICENSE_OR_PASSPORT, AttributeTypes.LICENSE_OR_PASSPORT_OR_BROWSE].includes(attributeType)
	) {
		return content.form.pickerInput.validUSDLText;
	}
	if (value === 'idcard') {
		return content.form.pickerInput.validIDCardText;
	}
	if (value === 'passport') {
		return content.form.pickerInput.validPassportText;
	}
	if (value === 'aadhar') {
		return content.form.pickerInput.validAadharCardText;
	}
	if (value === 'pan') {
		return content.form.pickerInput.validPANCardText;
	}
	return "";
};

export const getIDPropertyType = (type: AttributeTypes) => {
	switch (type) {
		case AttributeTypes.LICENSE_OR_ID_CARD:
			return 'licenseOrIDCard';
		case AttributeTypes.INTERNATIONAL_LICENSE_OR_PASSPORT:
		case AttributeTypes.LICENSE_OR_PASSPORT:
			return 'licenseOrPassport';
		case AttributeTypes.LICENSE_OR_PASSPORT_OR_BROWSE:
			return 'licenseOrPassport';
		case AttributeTypes.LICENSE_PASSPORT_OR_ID_CARD:
			return 'licensePassportOrIDCard';
		case AttributeTypes.PASSPORT_OR_ID_CARD:
			return 'passportOrIDCard';
		case AttributeTypes.AADHAR_PAN_OR_PASSPORT:
			return 'aadharPanOrPassport';
		default:
			return null;
	}
};
